import pkg from '../../package.json';

// Get version from environment variable (set at build time) or package.json
export const getVersion = () => {
  const version = process.env.REACT_APP_VERSION || pkg.version;
  // Check if we're on test environment and add "Test" prefix
  const hostname = typeof window !== 'undefined' ? window.location.hostname.toLowerCase() : '';
  const isTest = hostname.includes('test');
  return isTest ? `Test v${version}` : `v${version}`;
};

// Get build date (set at build time via REACT_APP_BUILD_DATE)
export const getBuildDate = () => {
  return process.env.REACT_APP_BUILD_DATE || new Date().toISOString().split('T')[0];
};

// Get git commit hash (set at build time via REACT_APP_GIT_COMMIT)
export const getGitCommit = () => {
  const commit = process.env.REACT_APP_GIT_COMMIT;
  return commit ? commit.substring(0, 7) : null;
};

// Get full version string
export const getFullVersion = () => {
  const version = getVersion();
  const commit = getGitCommit();
  return commit ? `${version} (${commit})` : version;
};

